// Утилита для обновления очков игроков на основе массива захваченных городов
export const updateWinPointsForCitiesCapture = (players, capturedCities) => {
  return players.map(player => {
    const winPointsToAdd = capturedCities.reduce((sum, city) => {
      const {
        fromPlayer,
        toPlayer,
        cityWinPoints,
      } = city;

      if (player.id === fromPlayer.id) {
        // Если у игрока захватили город, то он теряет очки
        return sum - cityWinPoints;
      } else if (player.id === toPlayer.id) {
        // Если игрок захватил город, то он получает очки
        return sum + cityWinPoints;
      } else {
        return sum;
      }
    }, 0)

    return {
      ...player,
      winPoints: Math.max(player.winPoints + winPointsToAdd, 0),
    }
  });
};